import { styled } from "../../gatsby-theme-stitches/config"
import React from "react"

export const StyledHeader = styled("header", {
  position: "sticky",
  top: 0,
  zIndex: 99,
  py: "$m",
  "-webkit-backdrop-filter": "blur(8px)",
  "backdrop-filter": "blur(8px)",
  borderBottom: "1px solid $border",
  backgroundColor: "$header",
  mt: "$l",
  px: "$l",
  "@tablet": {
    mt: "$xxl",
    px: "$xxl",
  },
})

export const NavigationItems = styled("ul", {
  listStyle: "none",
  p: 0,
  m: 0,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
})

export const Nav = styled("nav", {
  height: "$l",
  maxWidth: "1440px",
  margin: "0 auto",
  color: "$text",
})

export const PersonalDetailsNav = styled("ul", {
  listStyle: "none",
  p: 0,
  m: 0,
  display: "grid",
  gridTemplateColumns: "auto auto auto auto auto",
  alignItems: "center",
  gap: "$s",
  "@tablet": {
    gap: "$m",
  },
})

export const SiteNav = styled("ul", {
  listStyle: "none",
  p: 0,
  m: 0,
  gap: "$l",
  alignItems: "center",
  display: "grid",
  gridTemplateColumns: "auto",
  "@desktop": {
    gridTemplateColumns: "auto auto auto auto",
  },
})

export const DesktopNavItem = styled("li", {
  display: "none",
  "@desktop": {
    display: "list-item",
  },
})

export const SiteNavMobile = styled("ul", {
  listStyle: "none",
  gridTemplateColumns: "auto auto auto",
  gap: "$l",
  alignItems: "center",
  justifyContent: "space-between",
  display: "grid",
  position: "fixed",
  bottom: 0,
  zIndex: 99,
  m: "0 !important",
  background: "$border",
  borderTopLeftRadius: "$s",
  borderTopRightRadius: "$s",
  py: "$m",
  px: "$l",
  width: "100vw",
  maxWidth: "100%",
  boxSizing: "border-box",
  "@desktop": {
    display: "none",
  },
})

export const StyledClock = styled("div", {
  px: "$xs",
  py: "$xxs",
  background: "$border",
  borderRadius: "$s",
  color: "$textSecondary",
  display: "none",
  "@desktop": {
    display: "block",
  },
})
